import { Show } from "solid-js";
import { Package } from "lucide-solid";

import { Link } from "@/lib/u-router";
import { pressable } from "@/lib/motion";
import type { CatalogProductDTO } from "../data/catalog-rest";

/**
 * Tarjeta de producto del catálogo. Traducción del `code.html` de Stitch a
 * SolidJS + tokens Forest Nurture (no clon del HTML): imagen, título, categoría
 * y CTA a la ficha. El estado poseído/pendiente lo enriquece Wave 1-B.
 */
export function ProductCard(props: { product: CatalogProductDTO }) {
  return (
    <Link
      to="/catalog/$productId"
      params={{ productId: props.product.id }}
      data-testid="catalog-product-card"
      ref={(el: HTMLAnchorElement) => pressable(el, { scale: 0.96, hapticMs: 4 })}
      class="group flex w-full flex-col overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg"
    >
      <div class="relative aspect-square overflow-hidden bg-muted">
        <Show
          when={props.product.imageUrl}
          fallback={
            <div class="grid h-full w-full place-items-center text-muted-foreground/50">
              <Package class="h-10 w-10" />
            </div>
          }
        >
          <img
            src={props.product.imageUrl ?? ""}
            alt={props.product.editionName}
            loading="lazy"
            class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </Show>
        <Show when={props.product.isLimited}>
          <span class="absolute left-2 top-2 rounded-md bg-destructive px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-destructive-foreground shadow-sm">
            Rara
          </span>
        </Show>
      </div>
      <div class="flex flex-1 flex-col gap-0.5 p-3">
        <h3 class="line-clamp-2 text-sm font-semibold leading-tight text-foreground">
          {props.product.editionName}
        </h3>
        <Show when={props.product.category}>
          <p class="text-xs text-muted-foreground">{props.product.category}</p>
        </Show>
      </div>
    </Link>
  );
}
